import { useDispatch } from 'react-redux';
import { getOne } from '../App/actions';
import { COMPANIES } from '../../constants/endpointConstants';
import { getCompanyDataAction } from './actions';

export const useGetCompany = companyId => {
  const dispatch = useDispatch();
  const getCompany = () => {
    dispatch(
      getOne({
        endpoint: COMPANIES,
        id: companyId,
        sagaRoutine: getCompanyDataAction,
        params: {},
      }),
    );
  };
  return getCompany;
};
